import { createContext, useContext, useState } from "react";
import STRINGS from "../lib/i18n";

const LangCtx = createContext(null);

export const useLang = () => useContext(LangCtx);

export function LangProvider({ children }) {
  const [lang] = useState(() => localStorage.getItem("simashi_lang") || "en");

  const setLang = (l) => {
    if (l === lang) return;
    localStorage.setItem("simashi_lang", l);
    window.location.reload();
  };

  const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}
